import React from "react";
import { useQuery, gql } from "@apollo/client";

// Who has read the latest pay-rule changes in the app ("I understand"),
// and how many changes each professional hasn't acknowledged yet.

const GET_ACKS = gql`
  query GetRulebookAcknowledgements {
    getRulebookAcknowledgements {
      status
      message
      rows {
        employeeId
        fullName
        lastAcknowledgedAt
        unreadChanges
      }
    }
  }
`;

const RuleAcknowledgementsModal = ({ onClose }) => {
  const { data, loading } = useQuery(GET_ACKS, { fetchPolicy: "network-only" });
  const rows = [...(data?.getRulebookAcknowledgements?.rows || [])].sort(
    (a, b) => b.unreadChanges - a.unreadChanges,
  );
  const pending = rows.filter((r) => r.unreadChanges > 0).length;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-xl p-6 max-h-[85vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-1">
          <h2 className="text-lg font-semibold text-gray-800">Rule change acknowledgements</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-xl leading-none">
            ×
          </button>
        </div>
        <p className="text-xs text-gray-500 mb-3">
          Professionals see pay-rule changes in the app and tap "I understand".
          {!loading && ` ${pending} of ${rows.length} have unread changes.`}
        </p>
        {loading ? (
          <p className="text-sm text-gray-500">Loading...</p>
        ) : (
          <table className="min-w-full text-left text-sm text-gray-600">
            <thead className="bg-gray-50 text-gray-700 border-b">
              <tr>
                <th className="py-2 px-3">Professional</th>
                <th className="py-2 px-3">Last acknowledged</th>
                <th className="py-2 px-3 text-right">Unread changes</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {rows.map((r) => (
                <tr key={r.employeeId}>
                  <td className="py-2 px-3 text-gray-800">{r.fullName}</td>
                  <td className="py-2 px-3">
                    {r.lastAcknowledgedAt
                      ? new Date(r.lastAcknowledgedAt).toLocaleString("en-IN", {
                          timeZone: "Asia/Kolkata",
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })
                      : "Never"}
                  </td>
                  <td
                    className={`py-2 px-3 text-right font-semibold ${
                      r.unreadChanges > 0 ? "text-amber-700" : "text-green-700"
                    }`}
                  >
                    {r.unreadChanges}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default RuleAcknowledgementsModal;
